// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WhatsappWidget_whatsapp-chat-icon__OnYHo {
    position: fixed;
    bottom: 60px;
    right: 20px;
    width: 60px;
    height: 60px;
    background-color: #25D366;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 0px 15px -4px #000000;
    cursor: pointer;
    z-index: 1000;
  }
  
  .WhatsappWidget_whatsapp-chat-icon__OnYHo img {
    width: 35px;
    height: 35px;
  }
  
  .WhatsappWidget_whatsapp-chat-box__nF\\+Vk {
    position: fixed;
    bottom: 130px;
    right: 20px;
    width: 300px;
    background-color: #ffffff;
    border-radius: 10px;
    box-shadow: 0px 0px 15px -4px #000000;
    z-index: 1000;
    overflow: hidden;
  }
  
  .WhatsappWidget_whatsapp-chat-box-header__NPihP {
    display: flex;
    align-items: center;
    padding: 10px;
    background-color: #085E54;
    color: #ffffff;
  }
  
  .WhatsappWidget_whatsapp-chat-box-header__NPihP img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 10px;
  }
  
  .WhatsappWidget_whatsapp-chat-box-content__6j9Hk {
    padding: 10px;
  }
  
  .WhatsappWidget_whatsapp-chat-box-content__6j9Hk a {
    display: block;
    text-align: center;
    background-color: #25D366;
    color: #ffffff;
    padding: 10px;
    border-radius: 5px;
    text-decoration: none;
    margin-top: 10px;
  }
  
  .WhatsappWidget_whatsapp-chat-box-content__6j9Hk a:hover {
    background-color: #1EBF5B;
  }
  
  /* Hide WhatsApp chat icon and box on larger screens */
  @media (min-width: 768px) {
    .WhatsappWidget_whatsapp-chat-icon__OnYHo {
      display: none;
    }
  
    /* .whatsapp-chat-box {
      display: none;
    } */
  }
  `, "",{"version":3,"sources":["webpack://./src/components/ui/WhatsappWidget/WhatsappWidget.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,eAAe;IACf,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,aAAa;IACb,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,qCAAqC;IACrC,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,sDAAsD;EACtD;IACE;MACE,aAAa;IACf;;IAEA;;OAEG;EACL","sourcesContent":[".whatsapp-chat-icon {\n    position: fixed;\n    bottom: 60px;\n    right: 20px;\n    width: 60px;\n    height: 60px;\n    background-color: #25D366;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0px 0px 15px -4px #000000;\n    cursor: pointer;\n    z-index: 1000;\n  }\n  \n  .whatsapp-chat-icon img {\n    width: 35px;\n    height: 35px;\n  }\n  \n  .whatsapp-chat-box {\n    position: fixed;\n    bottom: 130px;\n    right: 20px;\n    width: 300px;\n    background-color: #ffffff;\n    border-radius: 10px;\n    box-shadow: 0px 0px 15px -4px #000000;\n    z-index: 1000;\n    overflow: hidden;\n  }\n  \n  .whatsapp-chat-box-header {\n    display: flex;\n    align-items: center;\n    padding: 10px;\n    background-color: #085E54;\n    color: #ffffff;\n  }\n  \n  .whatsapp-chat-box-header img {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    margin-right: 10px;\n  }\n  \n  .whatsapp-chat-box-content {\n    padding: 10px;\n  }\n  \n  .whatsapp-chat-box-content a {\n    display: block;\n    text-align: center;\n    background-color: #25D366;\n    color: #ffffff;\n    padding: 10px;\n    border-radius: 5px;\n    text-decoration: none;\n    margin-top: 10px;\n  }\n  \n  .whatsapp-chat-box-content a:hover {\n    background-color: #1EBF5B;\n  }\n  \n  /* Hide WhatsApp chat icon and box on larger screens */\n  @media (min-width: 768px) {\n    .whatsapp-chat-icon {\n      display: none;\n    }\n  \n    /* .whatsapp-chat-box {\n      display: none;\n    } */\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"whatsapp-chat-icon": `WhatsappWidget_whatsapp-chat-icon__OnYHo`,
	"whatsapp-chat-box": `WhatsappWidget_whatsapp-chat-box__nF+Vk`,
	"whatsapp-chat-box-header": `WhatsappWidget_whatsapp-chat-box-header__NPihP`,
	"whatsapp-chat-box-content": `WhatsappWidget_whatsapp-chat-box-content__6j9Hk`
};
export default ___CSS_LOADER_EXPORT___;
